import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import UnAuthorisedApp from "./UnAuthorisedApp";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "../components/common/ErrorBoundary";

const App = () => {
  return (
    <HelmetProvider>
      <React.Fragment>
        <ToastContainer />
        <ErrorBoundary>
          <Router>
            <UnAuthorisedApp />
          </Router>
        </ErrorBoundary>
      </React.Fragment>
    </HelmetProvider>
  );
};

export default App;
